import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthProvider';

type AuthenticatedRouteProps = {
  children: JSX.Element;
  withAuth?: boolean;
};

function BaseRoute({ children, withAuth }: AuthenticatedRouteProps) {
  const { isAuthenticated, isAdministrator } = useAuth();

  if (!withAuth) {
    if (isAuthenticated) {
      return (
        <Navigate
          to={isAdministrator ? '/administrator/dashboard' : '/admin/dashboard'}
          replace={true}
        />
      );
    }
  }

  return children;
}

export { BaseRoute };
